import React from 'react'
import { Drawer } from '@mui/material'

type DrawerProps = {
	open: boolean
	onClose: (v: boolean) => void
	children: React.ReactNode
}

export function DrawerCustom(props: DrawerProps) {
	return (
		<Drawer
			keepMounted
			sx={{
				'.MuiStack-root': {
					backgroundColor: '#151518',
					border: 'none',
				},
				'.MuiPaper-root': {
					backgroundColor: '#151518',
					border: 'none',
					position: 'absolute !important',
				},
			}}
			PaperProps={{
				style: { borderRadius: '15px 15px 0px 0px' },
			}}
			open={props.open}
			onClose={() => props.onClose(false)}
			anchor='bottom'
		>
			{props.children}
		</Drawer>
	)
}
